module.exports = __webpack_public_path__ + "img/setting_icon.cbf492a6.svg";